import React from 'react';
import styled from 'styled-components';
import { usePrayers } from '../hooks/usePrayers';

const Page = styled.div`
  background: var(--background);
  padding: 1.5rem;
  min-height: 100%;
`;

const HeaderTitle = styled.h1`
  margin: 0 0 1.5rem 0;
  font-size: 1.8rem;
  color: var(--onSurface);
`;

const TableCard = styled.div`
  background: var(--surface);
  border: 1px solid var(--outline);
  border-radius: 14px;
  box-shadow: 0 12px 24px rgba(17, 24, 39, 0.06);
  overflow: hidden;
`;

const TableWrap = styled.div`
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  th,
  td {
    padding: 0.75rem 1rem;
    border-bottom: 1px solid var(--outline);
    text-align: left;
    font-size: 0.9rem;
    color: var(--onSurfaceVariant);
  }

  th {
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--onSurfaceVariant);
    background: var(--surfaceVariant);
  }
  @media (max-width: 768px) {
    th,
    td {
      padding: 0.5rem 0.75rem;
      font-size: 0.85rem;
    }
  }
`;

export const PrayersPage: React.FC = () => {
  const { data, isLoading, error } = usePrayers();

  return (
    <Page>
      <HeaderTitle>Prayer Requests</HeaderTitle>
      {isLoading && <p>Loading prayers…</p>}
      {error && <p>Error loading prayers</p>}
      {!isLoading && !error && (
        <TableCard>
          <TableWrap>
            <Table>
              <thead>
              <tr>
                <th>Request</th>
                <th>Author</th>
                <th>Date</th>
                <th>Prayers</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((p) => (
                <tr key={p.id}>
                  <td style={{ maxWidth: 400 }}>{p.content?.slice(0, 140)}</td>
                  <td>{p.author_name}</td>
                  <td>{new Date(p.created_at).toLocaleDateString()}</td>
                  <td>{p.prayer_count ?? 0}</td>
                </tr>
              ))}
            </tbody>
            </Table>
          </TableWrap>
        </TableCard>
      )}
    </Page>
  );
};

export default PrayersPage;
